import $ from 'jquery';

/***
 * Code for MSH Create Account page
 */
$(function(){
    let createAccountForm = $(".portal-sign-in .form-panel_body form#attributeVerification");
    if( createAccountForm && createAccountForm.length > 0) {
        initCreateAccountFormEventHandlers(createAccountForm);
    }
});

/**
 * 
 * @param {jQuery Element} formElem Azure Create Account form jquery element
 */
function initCreateAccountFormEventHandlers(formElem){
    $(formElem).submit(function(){
        // Get all visible errors
        let formErrors = $(this).find(".error[aria-hidden=false]");
        if( formErrors && formErrors.length > 0){
            // clear out the passwords entered if we have any errors
            let password = $(this).find("#newPassword");
            password.val("");
            let confirmPassword = $(this).find("#reenterPassword");
            confirmPassword.val("");
        }
    });
}
